import { render, staticRenderFns } from "./PatientHeightCard.vue?vue&type=template&id=497c6436&scoped=true&"
import script from "./PatientHeightCard.vue?vue&type=script&lang=ts&"
export * from "./PatientHeightCard.vue?vue&type=script&lang=ts&"
import style0 from "./PatientHeightCard.vue?vue&type=style&index=0&id=497c6436&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../common/temp/node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497c6436",
  null
  
)

export default component.exports